import {FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Component, ContentChildren, EventEmitter, Input, AfterContentInit, Output, QueryList} from '@angular/core';
import {AbstractFilterComponent} from './abstract.filter.component';
import {FilterFieldClearDirective} from '../filter-field-clear.directive';
import {FormUtils} from '../../../../../common/utils';
import {isNullOrUndefined} from 'util';

@Component({
    selector: 'tfl-url-based-filter',
    template: require('./filter.template.html')
})
export class FilterUrlBasedComponent extends AbstractFilterComponent implements AfterContentInit {

    @Input('form') form: FormGroup;
    @Input('columns') columns: number = 3;
    @Input('verticalAlignment') verticalAlignment: boolean = false;

    @Output() onSearch: EventEmitter<any> = new EventEmitter();

    @ContentChildren(FilterFieldClearDirective) filterFieldComponents: QueryList<FilterFieldClearDirective>;

    constructor(private _router: Router,
                private _activatedRoute: ActivatedRoute) {
        super();
    }

    ngAfterContentInit(): void {
        this._activatedRoute.queryParams.subscribe(params => {
            let search = {};
            if (!!params.search) {
                try {
                    search = JSON.parse(params.search);
                } catch (e) {
                    // Catch any parse error
                    search = {};
                    console.error(e);
                }
            }

            if (!isNullOrUndefined(this.filterFieldComponents)) {
                this.filterFieldComponents.forEach(field => {
                    if (!isNullOrUndefined(search[field.controlName])) {
                        this.form.controls[field.controlName].setValue(search[field.controlName]);
                        FormUtils.updateValidity(this.form, field.controlName);
                    }
                });
            }

            setTimeout(() => {
                if (FormUtils.isValid(this.form)) {
                    this.onSearch.emit(this.form.value);
                }
            });
        });
    }

    submit(event, form) {
        if (FormUtils.isValid(form)) {
            this._router.navigate([], {
                queryParams: {search: JSON.stringify(form.value)},
                relativeTo: this._activatedRoute
            });
        }
    }

    reset() {
        let defValues = this.resetFieldsAndReturnDef();
        this._router.navigate([], {
            queryParams: {search: JSON.stringify(defValues)},
            relativeTo: this._activatedRoute
        });
    }

    private resetFieldsAndReturnDef() {
        let defValues: any = {};

        if (!isNullOrUndefined(this.filterFieldComponents)) {
            this.filterFieldComponents.forEach(field => {
                defValues = {...defValues, [field.controlName]: field.defValue};
                field.reset();
            });
        }

        return defValues;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/container/filter.url-based.component.ts